export const AUTHOR = {
  name: "Javier Alagrande",
  phrase: "La libertad de expresión es el derecho de susurrar lo que el poder prefiere callar.",
  bio: [
    "Escribo desde la sombra no por temor, sino por devoción a la verdad.",
    "Mis crónicas navegan entre la niebla del malecón, el hielo en el vaso corto y los secretos que nadie se atreve a firmar.",
    "El seudónimo es mi único escudo — y mi máxima libertad.",
  ],
};

export const IMAGES = {
  portrait:
    "https://images.unsplash.com/photo-1740163183765-8857762836f4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwzfHxkYXJrJTIwcG9ydHJhaXQlMjBzaGFkb3clMjBteXN0ZXJ5fGVufDB8fHx8MTc4Nzg1MDU1OXww&ixlib=rb-4.1.0&q=85",
  typewriter:
    "https://images.unsplash.com/photo-1652616555250-57d49a2034e2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwxfHx3aGlza3klMjBib29rJTIwZGFyayUyMGFlc3RoZXRpYyUyMG5vaXIlMjBsaWJyYXJ5JTIwcmVhZGluZyUyMHR5cGV3cml0ZXIlMjBteXN0ZXJ5fGVufDB8fHxibGFja3wxNzg3ODUwNTQ3fDA&ixlib=rb-4.1.0&q=85",
  whisky:
    "https://images.unsplash.com/photo-1456959890911-d3332c55bc7b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwyfHx3aGlza3klMjBib29rJTIwZGFyayUyMGFlc3RoZXRpYyUyMG5vaXIlMjBsaWJyYXJ5JTIwcmVhZGluZyUyMHR5cGV3cml0ZXIlMjBteXN0ZXJ5fGVufDB8fHxibGFja3wxNzg3ODUwNTQ3fDA&ixlib=rb-4.1.0&q=85",
};

export const MARQUEE_ITEMS = [
  "Libertad de expresión",
  "Literatura noir",
  "Javier Alagrande",
  "Toda la Verdad · Nada más que la verdad",
  "Ya disponible en Amazon",
  "Canales cifrados",
  "Anonimato consciente",
];

export const BOOKS = [
  {
    id: "libro-1",
    title: "Toda la Verdad",
    subtitle: "Nada más que la verdad",
    year: "2026",
    synopsis:
      "Juró proteger al Comandante. Nadie le advirtió que el enemigo estaba adentro. Yosel Valdés, militar y médico formado entre los campos de tabaco de Pinar del Río, llegó a caminar medio paso detrás de Fidel Castro y después a Caracas: la sombra impecable del poder. Hasta que empezó a mirar de verdad. Un thriller político implacable sobre el precio exacto del silencio de un hombre.",
    fragment: null,
    fullSynopsis: [
      "Juró proteger al Comandante. Nadie le advirtió que el enemigo estaba adentro.",
      "Yosel Valdés nació entre los campos de tabaco de Pinar del Río y creyó en la Revolución como se cree en una ley natural. Militar y médico, tirador de élite, hombre de silencio absoluto. Esa combinación lo llevó a caminar medio paso detrás de Fidel Castro por los jardines de La Habana. Y después, a Caracas.",
      "Durante años fue la sombra impecable del poder: el que revisa la comida, el que calcula las rutas de escape, el que sabe todo y no dice nada. Hasta que empezó a mirar de verdad. El desfalco disfrazado de solidaridad. La adulación como sistema. Los medicamentos que llegaban de La Habana sin pasar por los protocolos. Y unas pastillas que le entregaban a él mismo, presentadas como vitaminas.",
      "En medio del derrumbe encontró a Goretty Reyes, la única persona ante la que pudo dejar de ser un uniforme. Ella fue su refugio, su salvación y —sin saberlo ninguno de los dos— la grieta por donde se filtró todo.",
      "TODA LA VERDAD, nada más que la verdad es un thriller político implacable sobre los catorce días que no figuran en ningún parte oficial, sobre los millones que se movieron con una firma digital mientras un país lloraba en la calle, y sobre el precio exacto que tiene el silencio de un hombre: cien mil dólares y un pasaporte.",
      "En estas páginas: el ascenso de un soldado cubano hasta el círculo más cerrado del poder bolivariano; la guerra silenciosa entre médicos de La Habana y militares venezolanos alrededor de un cuerpo que se apagaba; una operación de inteligencia extranjera que no atacó una fortaleza, sino un afecto; una huida a medianoche por los Valles del Tuy hacia una pista sin torre de control; y la pregunta que persigue al narrador hasta un rancho en las montañas de Montana: ¿fue testigo, o instrumento?",
      "Una novela sobre la delgadísima frontera entre la lealtad y la traición, sobre lo que un ideal es capaz de justificar, y sobre el amor como el único territorio que ninguna doctrina pudo ocupar.",
      "Novela inspirada en hechos y personajes públicos reales. Los personajes principales, los diálogos y las situaciones narradas son producto de la imaginación del autor.",
    ],
    amazonUrl: "https://a.co/d/00OGkJAH",
    cover: "/cover-toda-la-verdad.jpg",
  },
];

export const MANIFESTO = [
  {
    num: "01",
    title: "El Arte de Desaparecer",
    body: "Desaparecer no es huir: es elegir el punto exacto desde donde la voz resuena más lejos. El escritor clandestino no oculta su obra; oculta su rostro para que la obra no tenga distracciones. Cada página que firmo con este seudónimo es una habitación sin ventanas donde, por fin, se puede decir todo en voz alta.",
  },
  {
    num: "02",
    title: "La Tinta No Pide Licencia",
    body: "Ninguna censura ha logrado jamás secar un tintero. La palabra escrita no solicita permisos ni rinde cuentas a los notarios del miedo. Escribo porque hay verdades que sólo caben en la ficción y ficciones que denuncian mejor que cualquier editorial. La tinta, como el agua, siempre encuentra la grieta.",
  },
  {
    num: "03",
    title: "El Hielo y la Memoria",
    body: "El hielo en el vaso se derrite despacio, igual que los regímenes: primero ceden los bordes, luego el centro. Escribir es ejercer la memoria contra el olvido administrado. Que conste en acta: alguien lo vio, alguien lo sufrió y alguien —desde un nombre prestado y un sombrero bajo— se negó a callarlo.",
  },
];

export const POSTS = [
  {
    id: "post-1",
    date: "28 · Junio · 2026",
    title: "Cartas desde la red oscura: escribir cuando te vigilan",
    excerpt:
      "Toda bitácora clandestina comienza con una precaución: asumir que alguien lee por encima de tu hombro. Esta entrada es un mapa mínimo de higiene digital para lectores curiosos y corresponsales valientes.",
    body: [
      "Toda bitácora clandestina comienza con una precaución: asumir que alguien lee por encima de tu hombro. No lo digo por dramatismo; lo digo por oficio. Quien escribe contra el poder aprende pronto que la prudencia no es miedo, es gramática.",
      "Usen navegadores que olvidan, correos que cifran y mensajería que no archiva. No por paranoia, sino por cortesía hacia quienes confían en uno sus secretos. Un corresponsal anónimo merece que su nombre se disuelva como el hielo: sin dejar rastro, pero habiendo enfriado algo.",
      "Escribiré cada quince días, como manda esta bitácora. Algunas entradas serán crónica, otras confesión, otras simple humo. Todas serán verdad a su manera.",
    ],
  },
  {
    id: "post-2",
    date: "14 · Junio · 2026",
    title: "El hielo se derrite; la palabra permanece",
    excerpt:
      "Hay quienes creen que el anonimato es una forma de cobardía. Se equivocan: es una forma de resistencia que exige más coraje que firmar con nombre y apellido en tiempos de aplauso.",
    body: [
      "Hay quienes creen que el anonimato es una forma de cobardía. Se equivocan: es una forma de resistencia que exige más coraje que firmar con nombre y apellido en tiempos de aplauso. El anónimo renuncia al laurel, al cargo, a la foto en la solapa. Sólo le queda la página.",
      "El hielo en el vaso tiene una virtud pedagógica: enfría sin prisa y desaparece sin escándalo. Así quiero esta bitácora. Fría, lenta, inevitable.",
      "Mientras tanto, las palabras de los que callaron a la fuerza siguen circulando de mano en mano, de servidor en servidor, como cartas en la guerra. Nada de eso se ha derretido. Nada de eso se derretirá.",
    ],
  },
  {
    id: "post-3",
    date: "31 · Mayo · 2026",
    title: "Por qué firmo con un nombre que no es mío",
    excerpt:
      "Javier Alagrande no nació en ningún registro civil. Nació una madrugada, frente a una máquina de escribir y un vaso de whisky, cuando entendí que la verdad necesitaba un rostro que el poder no pudiera borrar.",
    body: [
      "Javier Alagrande no nació en ningún registro civil. Nació una madrugada, frente a una máquina de escribir y un vaso de whisky, cuando entendí que la verdad necesitaba un rostro que el poder no pudiera borrar.",
      "Un seudónimo es una frontera inteligente: deja pasar las ideas y detiene a los sicarios. Detrás de él puedo escribir sobre lo que otros callan, nombrar a los innombrables y dedicarle a la libertad de expresión algo mejor que un discurso: una práctica.",
      "No pregunten quién soy. Pregunten, más bien, por qué hace falta que alguien como yo exista. Esa respuesta, esa sí, tiene nombre y apellido.",
    ],
  },
];

export const ARCHIVE = [
  {
    id: "arch-1",
    date: "17 · Mayo · 2026",
    title: "Manual breve del lector clandestino",
    body: [
      "Leer también tiene sus protocolos cuando los libros incomodan. Compren en efectivo cuando puedan, presten ejemplares en lugar de regalarlos, y aprendan a subrayar con lápiz: el grafito perdona, la tinta delata.",
      "Un lector clandestino no es un conspirador; es un ciudadano que se niega a que le resuman el mundo en un parte oficial. Cuiden sus bibliotecas. Son el único archivo que ningún decreto ha logrado formatear.",
    ],
  },
  {
    id: "arch-2",
    date: "03 · Mayo · 2026",
    title: "Censura con guantes de seda",
    body: [
      "La censura moderna ya no quema libros en plazas: los ahoga en trámites, los excluye de los algoritmos, los declara «fuera de catálogo». Es una hoguera fría, de guante blanco, que no deja ceniza sino ausencia.",
      "Contra ella no basta la indignación; hace falta oficio. Copiar, reeditar, traducir, leer en voz alta. Cada ejemplar prestado es un pequeño acto de desobediencia tipográfica.",
    ],
  },
  {
    id: "arch-3",
    date: "19 · Abril · 2026",
    title: "Crónica de un desaparecido voluntario",
    body: [
      "Hay desapariciones que no figuran en ningún expediente: la del periodista que dejó de preguntar, la del poeta que empezó a escribir «temas neutrales», la del editor que descubrió la virtud del silencio.",
      "A todos ellos, desaparecidos voluntarios, les dedico esta entrada. La puerta de la bitácora queda abierta. El whisky, como siempre, servido por dos.",
    ],
  },
  {
    id: "arch-4",
    date: "05 · Abril · 2026",
    title: "El noir como forma de resistencia",
    body: [
      "El género negro nació para contar lo que la crónica oficial perfumaba: la corrupción, el miedo, la doble moral de las instituciones. Por eso escribo noir: porque sus callejones son más honestos que muchos ministerios.",
      "En el noir nadie es inocente y casi nadie está a salvo, pero la verdad —esa detectivesca, obstinada verdad— siempre aparece en la última página. Qué género más optimista, a fin de cuentas.",
    ],
  },
  {
    id: "arch-5",
    date: "22 · Marzo · 2026",
    title: "Whisky, tinta y otras formas de memoria",
    body: [
      "Hay tres archivos que ningún régimen ha podido decomisar: el whisky añejo, la tinta fresca y la memoria de los abuelos. Los tres mejoran con el tiempo y los tres se comparten mejor de noche.",
      "Esta bitácora bebe de los tres. Salud.",
    ],
  },
  {
    id: "arch-6",
    date: "08 · Marzo · 2026",
    title: "Ajuste de cuentas con el silencio",
    body: [
      "Me acusaron, en algún pasillo, de escribir demasiado. Confieso el cargo y añado otro: pienso seguir haciéndolo. El silencio tuvo sus años, sus estatuas, sus archivos sellados. Le toca a la palabra cobrar la deuda.",
    ],
  },
];

export const CHANNELS = {
  proton: "javier.alagrande@proton.me",
  telegram: "t.me/AlagrandeCanal",
  session: "05f3a1c9e7b2d4f6081a3c5e7b9d2f4a6c8e0b1d3f5a7c9e2b4d6f8a0c1e3b5d7f",
};

export const PGP_KEY = `-----BEGIN PGP PUBLIC KEY BLOCK-----
Comment: Javier Alagrande <javier.alagrande@proton.me>

mQINBGZfX4kBEADQ7k9vR2mJxW8hL0pF3sN6qT1uY5vB8cD4eG7hJ0kL2mN5p
Q8rS1tU4vW7xY0zA3bC6dE9fG2hI5jK8lM1nO4pQ7rS0tU3vW6xY9zA2bC5dE
8fG1hI4jK7lM0nO3pQ6rS9tU2vW5xY8zA1bC4dE7fG0hI3jK6lM9nO2pQ5rS8
tU1vW4xY7zA0bC3dE6fG9hI2jK5lM8nO1pQ4rS7tU0vW3xY6zA9bC2dE5fG8
=wX7k
-----END PGP PUBLIC KEY BLOCK-----`;
